import { render, staticRenderFns } from "./modal-tow-vertical-btn.mpx?vue&type=template&id=1da101d1&isComponent&outputPath=components%2Fmodal-tow-vertical-btneebaaf8a%2Findex"
import script from "./modal-tow-vertical-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-tow-vertical-btneebaaf8a%2Findex"
export * from "./modal-tow-vertical-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-tow-vertical-btneebaaf8a%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports